<template>
    <MainContentSearchable title="Listado de campos para formularios" id="fields" v-model="filters" :meta="loading ? {} : fields.meta" @updated="debouncedGetFields">
        <template v-slot:header>
            <h3 class="card-title pt-2">Listado de campos para formularios</h3>
            <div class="card-tools mb-3">
                <router-link :to="{ name: 'back.formularios.crear' }" class="btn btn-primary" id="crear-campo">
                    Crear campo
                </router-link>
            </div>
        </template>

        <template v-slot:content>
            <ContentOrLoading>
                <div v-if="fields" :class="['table', { 'expanded': fields.data.length <= 3 }]">
                    <b-table v-if="!loading" hover :items="fields.data" :fields="campos">
                        <template #cell(type)="{ item }">
                            <section v-if="(item.type === 'select' || item.type === 'multiselect') && item.options.length > 0" :id="'select-options-tooltip-' + item.id">
                                <i class="fas fa-info-circle"></i>
                                {{ item.type }}
                                <b-tooltip :target="'select-options-tooltip-' + item.id" triggers="hover">
                                    <span v-for="(field, index) in item.options" :key="index" class="d-inline-block mr-1">
                                        {{ field.name }}
                                        <span v-if="index !== item.options.length - 1">, </span>
                                    </span>
                                </b-tooltip>
                            </section>
                            <section v-else>
                                {{ item.type }}
                            </section>
                        </template>
                        <template #cell(required)="{ item }">
                            <span v-if="item.required" class="mr-2"><i class="text-green fas fa-check-circle"></i></span>
                            <span v-else class="mr-2"><i class="text-danger fas fa-times-circle"></i></span>
                        </template>
                        <template #cell(opciones)="{ item, index }">
                            <OpcionesDropdownTableComponent 
                                :lastIndex="fields.data.length > 3 && index >= fields.data.length - 3"
                                v-bind:options="[
                                    { to: { name: 'back.formularios.editar', params: { field_id: item.id } }, label: 'Editar'},
                                    { type: 'action', action:() => showModal('delete-' + item.id), label: 'Borrar campo' },
                                ]"
                            />

                            <BorrarModalComponent
                                :name="'delete-' + item.id"
                                title="Borrar campo"
                                :borrarTitle="'Borrar campo ' + item.name + ' de tipo ' + item.type"
                                confirmButton="¿Está seguro de que quiere borrar este campo?"
                                @close="closeModal"
                                @confirm="deleteField(item.id)"
                            ></BorrarModalComponent>
                        </template>
                    </b-table>
                </div>
            </ContentOrLoading>
        </template>
    </MainContentSearchable>
</template>

<script>
import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent";
import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent";

export default {
    data() {
        return {
            loading: false,
            fields: null,
            filters: {
                per_page: 10,
                page: 1,
                search: ''
            },
            campos: [
                { key: "name", label: "Nombre", class: 'text-center' },
                { key: "type", label: "Tipo", class: 'text-center' },
                { key: "required", label: "Requerido", class: 'text-center' },
                { key: "opciones", label: "Opciones", class: 'text-center' }
            ],
        }
    },
    created() {
        this.getFields();
        this.debouncedGetFields = _.debounce(this.getFields, 500)
    },
    methods: {
        getFields() {
            this.loading = true;

            const params = {
                filters : this.filters,
                teatro_id: this.teatro.id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.teatro.forms.fields'), params).then(res => {
                this.fields = res.data;
            }).catch(error => {
                this.$toast.error(error.response.data.message);
            }).finally(() => {
                this.loading = false;
            });
        },
        showModal(modal) {
            this.$modal.show(modal);
        },
        closeModal(modal, updated) {
            this.$modal.hide(modal);
            if(updated) {
                this.getFields();
            }
        },
        deleteField(field_id) {
            const params = {
                filters : {
                    field_id: field_id,
                    teatro_id: this.teatro.id
                },
                field_id: field_id,
                teatro_id: this.teatro.id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.teatro.forms.delete'), params).then(res => {
                this.$toast.success(res.data.message);
            }).catch(error => {
                this.$toast.error(error.response.data.message);
            }).finally(() => {
                this.closeModal('delete-' + field_id, true);
            })
        }
    },
    computed: {
        teatro() {
            return this.$store.getters.getTeatro;
        }
    },
    components: {
        MainContentSearchable, OpcionesDropdownTableComponent, BorrarModalComponent
    }
}
</script>
<style scoped>
.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 150px !important;
}
</style>